import React from "react";
import clsx from "clsx";

const ButtonGroup = ({ buttons, selectedId, onChange }) => {
  return (
    <div className="flex w-full  overflow-x-auto whitespace-nowrap scrollbar-hide">
      <div className="grid grid-flow-col auto-cols-fr mx-auto min-w-max">
      {/* <div className="flex min-w-max mx-auto"> */}
        {buttons.map((btn, index) => {
          const isFirst = index === 0;
          const isLast = index === buttons.length - 1;
          const isSelected = btn.id === selectedId;

          // Button label (handles both strings & objects)
          const label = typeof btn === "string" ? btn : btn.label || btn.name;

          return (
            <button
              key={btn.id}
              type="button"
              onClick={() => onChange(btn.id)}
              className={clsx(
                "flex flex-1 items-center justify-center px-4 py-2 text-sm transition-all",
                isFirst && "rounded-l-full",
                isLast && "rounded-r-full border-l border-white",
                !isFirst && !isLast && "rounded-none border-l border-white",
                isSelected
                  ? "blueBackGroundColor text-white font-bold"
                  : "bg-gray-200 blackColor hover:bg-gray-100"
              )}
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ButtonGroup;
